import { render } from "./MaterialButton.vue?vue&type=template&id=9b5d5074&scoped=true&bindings={\"text\":\"props\",\"color\":\"props\",\"link\":\"props\",\"fontSize\":\"props\",\"padding\":\"props\",\"enabled\":\"props\",\"statusColor\":\"data\",\"styles\":\"options\",\"lintTo\":\"options\"}"
import script from "./MaterialButton.vue?vue&type=script&lang=js"
export * from "./MaterialButton.vue?vue&type=script&lang=js"

import "./MaterialButton.vue?vue&type=style&index=0&id=9b5d5074&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9b5d5074"

export default script